import React from 'react'

import { Box, Container, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { ErrorBoundary } from '@scoir/error-reporter'
import { get } from 'lodash'

import features from 'common/college-features'
import systemPermissions from 'common/system-permissions'
import useCollegeFeatures from 'common/use-college-features'
import useIsShadow from 'common/use-is-shadow'
import usePermissions from 'common/use-permissions'
import useTitle from 'common/use-title'

import ErrorMessage from '../../components/ErrorMessage'
import Metrics from './components/Metrics'
import MetricsTeaser from './components/MetricsTeaser'

const useStyles = makeStyles((theme) => ({
  componentWrapper: {
    backgroundColor: get(theme, 'palette.pageBackground.main'),
    paddingBottom: theme.spacing(10),
  },
}))

export const Dashboard = () => {
  useTitle('Scoir - Dashboard')
  const supportsAnalytics = useCollegeFeatures(features.SUPPORTS_STUDENT_ANALYTICS)
  const canUserSeeMetrics = usePermissions(systemPermissions.VIEW_COLLEGE_ENGAGEMENT_METRICS)
  const isShadowUser = useIsShadow()
  const showCollegeMetrics = (supportsAnalytics && canUserSeeMetrics) || isShadowUser
  const classes = useStyles()
  return (
    <Box
      className={classes.componentWrapper}
      px={[0, 3, 5]}
      py={5}
    >
      <Container maxWidth="lg">
        <Typography variant="srOnly">Dashboard</Typography>
        <ErrorBoundary errorComponent={ErrorMessage}>
          {showCollegeMetrics ? <Metrics /> : <MetricsTeaser />}
        </ErrorBoundary>
      </Container>
    </Box>
  )
}

export default Dashboard
